import { createAction, props } from '@ngrx/store';
import { WebCmsConfig } from '@api/rest';
import { NousToken } from '@app/shared/models/nous-token.model';
import { ChannelDto, MetaDto, OrganizationDetailDto, OrganizationDto } from '@api/organization';
import { Child } from '@app/shared/models/child';

export const setToken = createAction(
  '[Auth] Set Token',
  props<{ token: NousToken }>()
);

export const setWebConfig = createAction(
  '[Auth] Set Web Config',
  props<{ webConfig: WebCmsConfig }>()
);

export const setTextSize = createAction(
  '[App] Set Text Size',
  props<{ textSize: string }>()
);

export const setDownloadContent = createAction(
  '[App] Set Download Content',
  props<{ downloadContent: boolean }>()
);

export const setDarkMode = createAction(
  '[App] Set Dark Mode',
  props<{ darkMode: boolean }>()
);

export const setDownloadProgress = createAction(
  '[App] Set Download Progress',
  props<{ progress: number, count: number  }>()
);

export const setDownloadCount = createAction(
  '[App] Set Download Count',
  props<{ count: number  }>()
);

export const setDownloadComplete = createAction(
  '[App] Set Download Complete',
  props<{complete: boolean}>()
);


export const setOrganization = createAction(
  '[App] Set Organization',
  props<{ organization: OrganizationDto  }>()
);

export const setOrganizationDetail = createAction(
  '[App] Set Organization Detail',
  props<{ organizationDetail: OrganizationDetailDto  }>()
);

export const setDynamicContentUrl = createAction(
  '[App] Set Dynamic Content Url',
  props<{ contentUrl: string  }>()
);

export const setIsInhouse = createAction(
  '[App] Set is Inhouse',
  props<{ isInhouse: boolean  }>()
);

export const setDisableFavorites = createAction(
  '[App] Set Disable Favorites',
  props<{ disableFavorites: boolean  }>()
);

export const setDisableShare = createAction(
  '[App] Set Disable Share',
  props<{ disableShare: boolean  }>()
);

export const setLanguage = createAction(
  '[App] Set Language',
  props<{ language: string  }>()
);

export const setChannels = createAction(
  '[App] Set Channels',
  props<{ channels: ChannelDto[]  }>()
);

export const selectChannel = createAction(
  '[App] Select Channel',
  props<{ channel: ChannelDto }>()
);

export const setMeta = createAction(
  '[App] Set Meta',
  props<{ meta: MetaDto }>()
);

export const setUserId = createAction(
  '[App] Set User ID',
  props<{ userId: string }>()
);

export const addUnlockedChannel = createAction(
  '[App] Add unlocked Channel',
  props<{ channelId: string, code: string }>()
);

export const updateProfileAnswer = createAction(
  '[App] Update profile answer',
  props<{ id: string, value: number }>()
);

export const setSelectedName = createAction(
  '[App] Set selected name',
  props<{ name: string }>()
);

export const increaseAvatarXp = createAction(
  '[App] Increase avatar xp',
  props<{ xp: number }>()
);

export const setAvatarLevel = createAction(
  '[App] Set avatar level',
  props<{ avatarLevel: number }>()
);

export const setAcceptedEula = createAction(
  '[App] Set accepted eula',
  props<{ acceptedEula: boolean }>()
);

export const setReadInstructions = createAction(
  '[App] Set read instructions',
  props<{ readInstructions: boolean }>()
);

export const setFirstStart = createAction(
  '[App] Set first start',
  props<{ firstStart: boolean }>()
);

export const addDoneActivity = createAction(
  '[App] Add done activities',
  props<{ stationId: string }>()
);

export const addVisitedLexiconId = createAction(
  '[App] Add visited lexicon id',
  props<{ lexiconId: string }>()
);

export const setFinishAnimationShown = createAction(
  '[App] Set finish animation done',
  props<{ finishAnimationShown: boolean }>()
);

export const addChild = createAction(
  '[App] Add child',
  props<{ child: Child }>()
);

export const removeChild = createAction(
  '[App] Remove child',
  props<{ childId: string }>()
);

export const setSelectedChildId = createAction(
  '[App] Set selected child id',
  props<{ selectedChildId: string }>()
);